import Header from "../components/Header";
import { Outlet, useLocation } from "react-router-dom";
import { useEffect } from "react";

export default function RootLayout() {

    const { hash, pathname } = useLocation();

    useEffect(() => {
        if (hash) {
            // Delay scrolling to allow page to render
            setTimeout(() => {
                const element = document.querySelector(hash);
                if (element) {
                    const yOffset = -96; // adjust for sticky header height
                    const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
                    window.scrollTo({ top: y, behavior: "smooth" });
                }
            }, 50);
        } else {
            // Scroll to top on route change without hash
            window.scrollTo({ top: 0, behavior: "smooth" });
        }
    }, [hash, pathname]);

    return <>
        <main className="w-full max-w-6xl mx-auto bg-[#C9CCDD] shadow-md flex-grow">
            <Header />
            <Outlet/>
        </main>
        <footer className="w-full max-w-6xl mx-auto text-center p-5 bg-[#1C3353] text-white">
            Copyright © 2026 R&Co. Chartered Professional Accountant Prof. Corp.
        </footer>
    </>

}